import {
  FinanceBalanceState,
  FinanceBalanceTicketType
} from '@/api/models/finance'

import {
  ticketAllPaidTypeName,
  ticketDefaultImageProps,
  ticketMainTypeName,
  ticketNoInvoicesTypeName,
  ticketNotPaidImageProps,
  ticketTitle
} from './tickets.constants'
import { BalanceSummaryVariant } from './tickets.types'

export const isTicketPaid = (ticket: FinanceBalanceTicketType) => {
  return ticket.debtSum === 0
}

export const getTicketImageProps = (ticket: FinanceBalanceTicketType) => {
  if (ticket.state === FinanceBalanceState.NotPaid) {
    return ticketNotPaidImageProps[ticket.type]
  }

  return ticketDefaultImageProps[ticket.state]
}

export const getTicketTitle = (
  ticket: FinanceBalanceTicketType,
  variant: BalanceSummaryVariant
) => {
  if (variant === 'main') {
    return ticketTitle[ticket.state]
  }

  return 'Ваши счета'
}

export const getTicketDetailTypeName = (ticket: FinanceBalanceTicketType) => {
  switch (ticket.state) {
    case FinanceBalanceState.AllPaid: {
      return ticketAllPaidTypeName[ticket.type]
    }
    case FinanceBalanceState.NoInvoices: {
      return ticketNoInvoicesTypeName[ticket.type]
    }
  }
}

export const getTicketTypeName = (
  ticket: FinanceBalanceTicketType,
  variant: BalanceSummaryVariant
) => {
  switch (variant) {
    case 'main': {
      return ticketMainTypeName[ticket.type]
    }
    case 'detail': {
      return getTicketDetailTypeName(ticket)
    }
  }
}
